<router-outlet></router-outlet>
<ngx-spinner [fullScreen]="true" type="line-scale" color="#fff" size="small" bdColor="rgba(0,0,0,0.9)">
  <p style="color: #fff">Loading...</p>
</ngx-spinner>
